export const status = {
  scheduled: 'Agendado',
  canceled: 'Cancelado',
  absent: 'Ausente',
  attended: 'Atendido',
  present: 'Presente',
  attedance: 'Em Atendoiemnto',
  pending: 'Pendente'

}

export const getOptionsStatus = () => {
  return Object.keys(status).map((key) => {
    return {
      id: key,
      label: status[key]
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/resources/dataStatus.js